// Electric Potential (Voltage) units with conversion factors to volt (V)
export const electricPotentialUnits = [
  { id: 'volt', name: 'Volt', symbol: 'V', plural: 'Volts', factor: 1 },
  { id: 'megavolt', name: 'Megavolt', symbol: 'MV', plural: 'Megavolts', factor: 1e6 },
  { id: 'kilovolt', name: 'Kilovolt', symbol: 'kV', plural: 'Kilovolts', factor: 1e3 },
  { id: 'millivolt', name: 'Millivolt', symbol: 'mV', plural: 'Millivolts', factor: 1e-3 },
  { id: 'microvolt', name: 'Microvolt', symbol: 'µV', plural: 'Microvolts', factor: 1e-6 },
  { id: 'nanovolt', name: 'Nanovolt', symbol: 'nV', plural: 'Nanovolts', factor: 1e-9 },
  { id: 'abvolt', name: 'Abvolt', symbol: 'abV', plural: 'Abvolts', factor: 1e-8 },
  { id: 'statvolt', name: 'Statvolt', symbol: 'statV', plural: 'Statvolts', factor: 299.7924580 },
  { id: 'watt-per-ampere', name: 'Watt/Ampere', symbol: 'W/A', plural: 'Watts/Ampere', factor: 1 },
  { id: 'joule-per-coulomb', name: 'Joule/Coulomb', symbol: 'J/C', plural: 'Joules/Coulomb', factor: 1 },
];

export const popularElectricPotentialConversions = [
  { from: 'volt', to: 'millivolt' },
  { from: 'millivolt', to: 'volt' },
  { from: 'volt', to: 'kilovolt' },
  { from: 'kilovolt', to: 'volt' },
  { from: 'volt', to: 'microvolt' },
  { from: 'millivolt', to: 'microvolt' },
];

export const getUnitById = (id) => electricPotentialUnits.find(unit => unit.id === id);

export const convertElectricPotential = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electric potential (voltage) units and learn the conversion formula.`;
};
